import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickLinksRoutingModule } from './quick-links-routing.module';
import { StudentTestimonialComponent } from './student-testimonial/student-testimonial.component';
import {ReactiveFormsModule} from "@angular/forms";
import { NewsComponent } from './news/news.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';

@NgModule({
  declarations: [
    StudentTestimonialComponent,
    NewsComponent,
    ContactUsComponent,
    ImageGalleryComponent,
  ],
    imports: [
        CommonModule,
        QuickLinksRoutingModule,
        ReactiveFormsModule
    ]
})
export class QuickLinksModule { }
